import styled from 'styled-components'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { ChatbotWidget } from '../shared/ChatbotWidget'
import { useAuth } from '../../contexts/AuthContext'

const LayoutContainer = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
`

const MainContent = styled.main`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.xl} ${({ theme }) => theme.spacing.xl};
`

const ContentCard = styled.div`
  background: ${({ theme }) => theme.colors.cardBg};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  padding: ${({ theme }) => theme.spacing.xl};
  box-shadow: ${({ theme }) => theme.shadows.sm};
`

export const MainLayout: React.FC = () => {
    const { user } = useAuth()
    const isAdmin = user?.role?.toLowerCase() === 'admin'

    return (
        <LayoutContainer className="animate-fade-in">
            <Header />
            <MainContent>
                <ContentCard>
                    <Outlet />
                </ContentCard>
            </MainContent>
            {isAdmin && <ChatbotWidget />}
        </LayoutContainer>
    )
}
